// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_outbound_ui_styles" + "." + "4c1bdbac" + ".chunk.css";
};